import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
	onSuccess?: () => void;
};

export const useRequestCancelAdminMessage = (params?: TParams) => {
	const queryClient = useQueryClient();
	const { isPending, mutateAsync, error } = useMutation({
		mutationFn: (messageId: string) =>
			apiClient
				.post(routes.api.cancelAdminMessage(messageId))
				.then(handleApiResponse),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [routes.api.adminMessagesList] });
			params?.onSuccess?.();
		},
	});

	return {
		isLoading: isPending,
		cancelMessage: mutateAsync,
		error,
	};
};
